import { axios } from '@src/plugins/axios-pol'

const basePath = '/armeria/api/Armeria'

export default class NotificacionesApiRepository {
  static async getAll() {
    const { data } = await axios.get(`${basePath}/notificaciones`)
    return data
  }

  static async create(notificacion) {
    const { data } = await axios.post(`${basePath}/notificaciones`, notificacion)
    return data
  }

  static async update(idNotificacion, notificacion) {
    const { data } = await axios.put(`${basePath}/notificaciones/${idNotificacion}`, notificacion)
    return data
  }
}
